import React from 'react';
import {Paper,Typography} from '@material-ui/core/';

const SubSection = props => (
  <Paper style={{
    backgroundColor: "#3a8b682f",
    marginTop: ".25rem",
    marginBottom: ".25rem",
  }}>
  <Typography component="div">
    {props.children}  
  </Typography>  
  </Paper>
);

export default SubSection;


// WEBPACK FOOTER //
// ./src/pages/SubSection.js